import { render, staticRenderFns } from "./SuccessIcon.vue?vue&type=template&id=3180587b&scoped=true"
import script from "./SuccessIcon.vue?vue&type=script&lang=js"
export * from "./SuccessIcon.vue?vue&type=script&lang=js"
import style0 from "./SuccessIcon.vue?vue&type=style&index=0&id=3180587b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3180587b",
  null
  
)

export default component.exports